import { StoreState } from '@mm/state/store-interfaces';
import { useSelector } from 'react-redux';
import { selectMyLeadsContacts } from '@mm/state/selectors/myLeadsSelectors';
import { Contact } from '@mm/state/interfaces/contacts';
import moment from 'moment';

export const useDummyContacts = () => {
  const companies = useSelector((state: StoreState) => state.company.entities);
  const facebookPage = useSelector(
    (state: StoreState) => state.connectedPage.pageDetails,
  );
  const activeCompany = companies.find(c => c.id === facebookPage?.companyId);
  const myLeads = useSelector(selectMyLeadsContacts);
  const leads = Array.isArray(myLeads) ? (myLeads as Contact[]) : [];
  const dummyLeads = leads?.filter(lead => lead.dummy);

  const contacts = dummyLeads.map((lead: Contact) => ({
    ...lead,
    sessions: [],
    notes: [],
    tags: [],
    leadScoring: {
      time: moment.duration(174, 'seconds').as('milliseconds'),
      sessions: 1,
      views: 3,
      scroll: 5184,
      clicks: 7,
    },
    variables: [
      {
        value: lead.firstName,
        variable: {
          name: 'first name',
          system: true,
        },
      },
      {
        value: lead.lastName,
        variable: {
          name: 'last name',
          system: true,
        },
      },
      {
        value: lead.email,
        variable: {
          name: 'EMAIL',
          system: true,
        },
      },
      {
        value: lead.createdAt,
        variable: {
          name: 'created',
          system: true,
        },
      },
      {
        value: lead.source,
        variable: {
          name: 'source',
          system: true,
        },
      },
      {
        value: 'https://www.google.com',
        variable: {
          name: 'REFERRER',
          system: true,
        },
      },
      {
        value: `https://${activeCompany?.website}`,
        variable: {
          name: 'LANDING_PAGE_URL',
          system: true,
        },
      },
      {
        value: false,
        variable: {
          name: 'Email click',
          system: true,
        },
      },
      {
        value: false,
        variable: {
          name: 'Email send',
        },
      },
      {
        value: true,
        variable: {
          name: 'UNSUBSCRIBED',
          friendlyName: 'subscribed',
          system: true,
        },
      },
    ],
  }));
  return contacts;
};
